export default __webpack_public_path__ + "static/media/Logo.ae0b8139.png";